import { useEffect, useLayoutEffect, useState, useRef } from 'react'
import { Popover } from 'antd'
import ScrollAnimation from './ScrollAnimation'
import phone from '@/assets/images/home/phone.svg'
import AutoSwitch from './AutoSwitch'
import ActiveImg from './ActiveImg'
import styles from './productCenter.module.less'
import type { Anchor } from '../index'
import { TRAIN_PLATFORM, CREATE_DIGITAL, CHAT_DIGITAL } from '../config'
import contact_us from '@/assets/images/home/contact_us.png'
import zdtc_code from '@/assets/images/home/zdtc_code.png'
import prd_appset from '@/assets/images/home/prd_appset.svg'
import prd_chat from '@/assets/images/home/prd_chat.svg'
import prd_library from '@/assets/images/home/prd_library.svg'
import prd_app from '@/assets/images/home/prd_app.svg'
import prd_chat_content from '@/assets/images/home/prd_chat_content.png'
import prd_appset_content from '@/assets/images/home/prd_appset_content.png'
import prd_library_content from '@/assets/images/home/prd_library_content.png'
import prd_app_content from '@/assets/images/home/prd_app_content.png'
import prd_data from '@/assets/images/home/prd_data.svg'
import prd_model from '@/assets/images/home/prd_model.svg'
import prd_server from '@/assets/images/home/prd_server.svg'
import prd_data_content from '@/assets/images/home/prd_data_content.png'
import prd_model_content from '@/assets/images/home/prd_model_content.png'
import prd_server_content from '@/assets/images/home/prd_server_content.png'
import prd_machine from '@/assets/images/home/prd_machine.svg'
import prd_create from '@/assets/images/home/prd_create.svg'
import prd_machine_content from '@/assets/images/home/prd_machine_content.png'
import prd_create_content from '@/assets/images/home/prd_create_content.png'
import heterogeneous from '@/assets/images/home/heterogeneous.png'
import heterogeneous_active from '@/assets/images/home/heterogeneous_active.png'
import cross_domain from '@/assets/images/home/cross_domain.png'
import cross_domain_active from '@/assets/images/home/cross_domain_active.png'
import efficient from '@/assets/images/home/efficient.png'
import efficient_active from '@/assets/images/home/efficient_active.png'
import real_time from '@/assets/images/home/real_time.png'
import real_time_active from '@/assets/images/home/real_time_active.png'
import prdBg1 from '@/assets/images/home/prd_bg1.png'
import prdBg2 from '@/assets/images/home/prd_bg2.png'
import prdBg3 from '@/assets/images/home/prd_bg3.png'
import prdBg4 from '@/assets/images/home/prd_bg4.png'

const ProductCenter = ({ anchorPoint }: { anchorPoint: Anchor }) => {
  const sectionRefs = useRef<Record<string, HTMLElement | null>>({})
  const [isPaused, setIsPaused] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0)
  const computingItems = [
    {
      id: 1,
      contentImg: heterogeneous,
      className: 'rounded-[20px] lg:min-w-[161px]',
      content: (
        <>
          <div className="absolute text-white w-full flex-col pt-4 sm:pt-6 z-10">
            <div className="text-center text-[10px] sm:text-[14px] lg:text-[20px] xl:text-[22px] 2xl:text-[32px] font-bold">
              异构资源调度
            </div>
            <div
              className={`text-white w-full h-full px-4 sm:px-8 lg:px-8 xl:px-10 2xl:px-12 py-[8px] sm:py-[16px] z-10 text-[6px] sm:text-[8px] md:text-[12px] lg:text-[14px] transition-opacity duration-500 ${activeIndex === 0 ? 'opacity-100' : 'opacity-0'}`}
            >
              对不同类型的计算资源进行统一管理和优化分配，以提升处理效率和资源利用率
            </div>
          </div>
        </>
      ),
      activeContentImg: heterogeneous_active,
    },
    {
      id: 2,
      contentImg: cross_domain,
      className: 'rounded-[20px] lg:min-w-[161px]',
      content: (
        <>
          <div className="absolute text-white w-full flex-col pt-4 sm:pt-6 z-10">
            <div className="text-center text-[10px] sm:text-[14px] lg:text-[20px] xl:text-[22px] 2xl:text-[32px] font-bold">
              跨域资源调度
            </div>
            <div
              className={`text-white w-full h-full px-4 sm:px-8 lg:px-8 xl:px-10 2xl:px-12 py-[8px] sm:py-[16px] z-10 text-[6px] sm:text-[8px] md:text-[12px] lg:text-[14px] transition-opacity duration-500 ${activeIndex === 1 ? 'opacity-100' : 'opacity-0'}`}
            >
              在多个区域资源中心之间，根据任务需求和资源状况，智能调配和动态迁移资源
            </div>
          </div>
        </>
      ),
      activeContentImg: cross_domain_active,
    },
    {
      id: 3,
      contentImg: efficient,
      className: 'rounded-[20px] lg:min-w-[161px]',
      content: (
        <>
          <div className="absolute text-white w-full flex-col pt-4 sm:pt-6 z-10">
            <div className="text-center text-[10px] sm:text-[14px] lg:text-[20px] xl:text-[22px] 2xl:text-[32px] font-bold">
              高效调度策略
            </div>
            <div
              className={`text-white w-full h-full px-4 sm:px-8 lg:px-8 xl:px-10 2xl:px-12 py-[8px] sm:py-[16px] z-10 text-[6px] sm:text-[8px] md:text-[12px] lg:text-[14px] transition-opacity duration-500 ${activeIndex === 2 ? 'opacity-100' : 'opacity-0'}`}
            >
              优化调度逻辑，预先分析任务需求，快速匹配所需资源，减少排队和等待时间
            </div>
          </div>
        </>
      ),
      activeContentImg: efficient_active,
    },
    {
      id: 4,
      contentImg: real_time,
      className: 'rounded-[20px] lg:min-w-[161px]',
      content: (
        <>
          <div className="absolute text-white w-full flex-col pt-4 sm:pt-6 z-10">
            <div className="text-center text-[10px] sm:text-[14px] lg:text-[20px] xl:text-[22px] 2xl:text-[32px] font-bold">
              资源实时监控
            </div>
            <div
              className={`text-white w-full h-full px-4 sm:px-8 lg:px-8 xl:px-10 2xl:px-12 py-[8px] sm:py-[16px] z-10 text-[6px] sm:text-[8px] md:text-[12px] lg:text-[14px] transition-opacity duration-500 ${activeIndex === 3 ? 'opacity-100' : 'opacity-0'}`}
            >
              实时监控资源状态并精准统计，预警潜在风险与故障，确保资源高效稳定运行
            </div>
          </div>
        </>
      ),
      activeContentImg: real_time_active,
    },
  ]

  useEffect(() => {
    if (isPaused || computingItems.length <= 1) return

    const timer = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % computingItems.length)
    }, 3000)

    return () => {
      clearInterval(timer)
    }
  }, [activeIndex, isPaused, computingItems.length])

  useLayoutEffect(() => {
    if (anchorPoint.anchor && sectionRefs.current[anchorPoint.anchor]) {
      const element = sectionRefs.current[anchorPoint.anchor]
      if (element) {
        const topPos = element.offsetTop
        window.scrollTo({
          top: topPos,
          behavior: 'smooth',
        })
      }
    }
  }, [anchorPoint.anchor, anchorPoint.timestamp])

  const chatItems = [
    {
      id: 1,
      title: (
        <div className="flex items-center gap-2 pl-[5px] text-white text-[6px] sm:text-[10px] md:text-[14px] lg:text-[18px]">
          <img
            className="lg:w-[16px] md:w-[14px] sm:w-[12px] w-[10px]"
            src={prd_chat}
            alt=""
          />
          对话功能
        </div>
      ),
      content: <img src={prd_chat_content} alt="" />,
      className:
        'p-[5px] border-l-[2px] border-transparent bg-gradient-to-r from-[#71479f80] to-transparent',
      activeClassName:
        'p-[5px] border-l-[2px] border-purple-500 bg-gradient-to-r from-[#71479f] to-transparent',
    },
    {
      id: 2,
      title: (
        <div className="flex items-center gap-2 pl-[5px] text-white text-[6px] sm:text-[10px] md:text-[14px] lg:text-[18px]">
          <img
            className="lg:w-[16px] md:w-[14px] sm:w-[12px] w-[10px]"
            src={prd_appset}
            alt=""
          />
          应用集功能
        </div>
      ),
      content: <img src={prd_appset_content} alt="" />,
      className:
        'p-[5px] border-l-[2px] border-transparent bg-gradient-to-r from-[#71479f80] to-transparent',
      activeClassName:
        'p-[5px] border-l-[2px] border-purple-500 bg-gradient-to-r from-[#71479f] to-transparent',
    },
    {
      id: 3,
      title: (
        <div className="flex items-center gap-2 pl-[5px] text-white text-[6px] sm:text-[10px] md:text-[14px] lg:text-[18px]">
          <img
            className="lg:w-[16px] md:w-[14px] sm:w-[12px] w-[10px]"
            src={prd_library}
            alt=""
          />
          知识库功能
        </div>
      ),
      content: <img src={prd_library_content} alt="" />,
      className:
        'p-[5px] border-l-[2px] border-transparent bg-gradient-to-r from-[#71479f80] to-transparent',
      activeClassName:
        'p-[5px] border-l-[2px] border-purple-500 bg-gradient-to-r from-[#71479f] to-transparent',
    },
    {
      id: 4,
      title: (
        <div className="flex items-center gap-2 pl-[5px] text-white text-[6px] sm:text-[10px] md:text-[14px] lg:text-[18px]">
          <img
            className="lg:w-[16px] md:w-[14px] sm:w-[12px] w-[10px]"
            src={prd_app}
            alt=""
          />
          紫东太初App
        </div>
      ),
      content: <img src={prd_app_content} alt="" />,
      className:
        'p-[5px] border-l-[2px] border-transparent bg-gradient-to-r from-[#71479f80] to-transparent',
      activeClassName:
        'p-[5px] border-l-[2px] border-purple-500 bg-gradient-to-r from-[#71479f] to-transparent',
    },
  ]

  const digitalHumanItems = [
    {
      id: 1,
      title: (
        <div className="flex items-center gap-2 pl-[5px] text-white text-[6px] sm:text-[10px] md:text-[14px] lg:text-[18px]">
          <img
            className="lg:w-[16px] md:w-[14px] sm:w-[12px] w-[10px]"
            src={prd_machine}
            alt=""
          />
          数字人交互一体机
        </div>
      ),
      content: <img src={prd_machine_content} alt="" />,
      className:
        'p-[5px] border-l-[2px] border-transparent bg-gradient-to-r from-[#71479f80] to-transparent',
      activeClassName:
        'p-[5px] border-l-[2px] border-purple-500 bg-gradient-to-r from-[#71479f] to-transparent',
    },
    {
      id: 2,
      title: (
        <div className="flex items-center gap-2 pl-[5px] text-white text-[6px] sm:text-[10px] md:text-[14px] lg:text-[18px]">
          <img
            className="lg:w-[16px] md:w-[14px] sm:w-[12px] w-[10px]"
            src={prd_create}
            alt=""
          />
          数字人创作平台
        </div>
      ),
      content: <img className="w-full" src={prd_create_content} alt="" />,
      className:
        'p-[5px] border-l-[2px] border-transparent bg-gradient-to-r from-[#71479f80] to-transparent',
      activeClassName:
        'p-[5px] border-l-[2px] border-purple-500 bg-gradient-to-r from-[#71479f] to-transparent',
    },
  ]

  const trainItems = [
    {
      id: 1,
      title: (
        <div className="flex items-center gap-2 pl-[5px] text-white text-[6px] sm:text-[10px] md:text-[14px] lg:text-[18px]">
          <img
            className="lg:w-[16px] md:w-[14px] sm:w-[12px] w-[10px]"
            src={prd_data}
            alt=""
          />
          数据中心
        </div>
      ),
      content: <img src={prd_data_content} alt="" />,
      className:
        'px-[10px] py-[7px] rounded-l-full bg-gradient-to-r from-[#71479f80] to-transparent',
      activeClassName:
        'px-[10px] py-[7px] rounded-l-full bg-gradient-to-r from-[#71479f] to-transparent',
    },
    {
      id: 2,
      title: (
        <div className="flex items-center gap-2 pl-[5px] text-white text-[6px] sm:text-[10px] md:text-[14px] lg:text-[18px]">
          <img
            className="lg:w-[16px] md:w-[14px] sm:w-[12px] w-[10px]"
            src={prd_model}
            alt=""
          />
          模型微调
        </div>
      ),
      content: <img src={prd_model_content} alt="" />,
      className:
        'px-[10px] py-[7px] rounded-l-full bg-gradient-to-r from-[#71479f80] to-transparent',
      activeClassName:
        'px-[10px] py-[7px] rounded-l-full bg-gradient-to-r from-[#71479f] to-transparent',
    },
    {
      id: 3,
      title: (
        <div className="flex items-center gap-2 pl-[5px] text-white text-[6px] sm:text-[10px] md:text-[14px] lg:text-[18px]">
          <img
            className="lg:w-[16px] md:w-[14px] sm:w-[12px] w-[10px]"
            src={prd_server}
            alt=""
          />
          服务部署
        </div>
      ),
      content: <img src={prd_server_content} alt="" />,
      className:
        'px-[10px] py-[7px] rounded-l-full bg-gradient-to-r from-[#71479f80] to-transparent',
      activeClassName:
        'px-[10px] py-[7px] rounded-l-full bg-gradient-to-r from-[#71479f] to-transparent',
    },
  ]

  const handleMouseEnter = (index: number) => {
    setIsPaused(true)
    setActiveIndex(index)
  }

  const handleMouseLeave = () => {
    setIsPaused(false)
  }

  return (
    <div className="bg-overlay-dark w-full">
      {/* 第一部分 */}
      <div
        ref={el => {
          sectionRefs.current.prd_chat = el
        }}
        className="bg-overlay-dark bg-cover flex-center h-[100vh] min-h-[650px] sm:min-h-[800px] md:min-h-[900px]"
        style={{
          backgroundImage: `url(${prdBg1})`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="max-w-[1000px] mx-auto flex flex-col justify-center items-center">
          <div className="flex-col flex-center">
            <ScrollAnimation>
              <div
                style={{ fontWeight: '900', letterSpacing: '4px' }}
                className="text-[30px] md:text-[40px] lg:text-[60px] text-white"
              >
                紫东太初对话平台
              </div>
            </ScrollAnimation>
            <ScrollAnimation>
              <div className="mt-[10px] mb-[40px] text-center text-[16px] text-white">
                面向图文音视海量异构数据的智能化对话工具
              </div>
            </ScrollAnimation>
          </div>
          <div className={`flex gap-6 ${styles.productCenterPop}`}>
            <div
              onClick={() => window.open('/#/chat', '_blank')}
              className="lg:w-[145px] w-[120px] lg:h-[50px] md:h-[40] h-[30px] cursor-pointer px-[20px] text-[14px] lg:px-[30px] lg:text-[18px] hover:text-white text-white rounded-full flex-center hover:bg-gradient-to-r hover:from-[#86abff] hover:to-[#d1a2ff] bg-gradient-to-r from-[#1854f8] to-[#b678fe]"
            >
              立即体验
            </div>
            <Popover
              getPopupContainer={node => {
                return node
              }}
              trigger="hover"
              placement="rightTop"
              color="transparent"
              arrow={false}
              content={<img src={zdtc_code} />}
            >
              <div>
                <div
                  className={`${styles.botonElegante} lg:w-[145px] w-[120px] lg:h-[50px] md:h-[40] h-[30px] cursor-pointer px-[16px] text-[14px] lg:px-[25px] lg:text-[18px] text-white rounded-full flex-center`}
                >
                  <img src={phone} />
                  &nbsp;App下载
                </div>
              </div>
            </Popover>
          </div>
          <ScrollAnimation>
            <AutoSwitch
              items={chatItems}
              interval={2000}
              startActiveIndex={0}
            />
          </ScrollAnimation>
        </div>
      </div>
      {/* 第二部分 */}
      <div
        ref={el => {
          sectionRefs.current.prd_computing = el
        }}
        className="bg-overlay-dark bg-cover flex-center h-[100vh] min-h-[550px] sm:min-h-[800px] md:min-h-[900px]"
        style={{
          backgroundImage: `url(${prdBg2})`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="w-full mx-auto flex flex-col justify-center items-center">
          <div className="flex-col flex-center">
            <ScrollAnimation>
              <div
                style={{ fontWeight: '900', letterSpacing: '4px' }}
                className="text-[30px] md:text-[40px] lg:text-[60px] text-white"
              >
                太初智算：算力服务平台
              </div>
            </ScrollAnimation>
            <ScrollAnimation>
              <div className="w-[90vw] mt-[10px] mb-[40px] text-center text-[16px] text-white">
                拥有遍布全国的强大算力资源和行业领先的专业算力服务，致力于为企业和个人提供高效、安全、稳定的算力解决方案
              </div>
            </ScrollAnimation>
          </div>
          <div className={`flex gap-6 ${styles.productCenterPop}`}>
            <Popover
              getPopupContainer={node => {
                return node
              }}
              trigger="hover"
              color="transparent"
              arrow={false}
              placement="rightTop"
              content={<img src={contact_us} />}
            >
              <div className="lg:w-[140px] mb-[40px] w-[120px] lg:h-[50px] md:h-[40] h-[30px] cursor-pointer px-[20px] text-[14px] lg:px-[30px] lg:text-[18px] hover:text-white text-white rounded-full flex-center hover:bg-gradient-to-r hover:from-[#86abff] hover:to-[#d1a2ff] bg-gradient-to-r from-[#1854f8] to-[#b678fe]">
                联系我们
              </div>
            </Popover>
          </div>
          <ScrollAnimation className="w-full">
            <div className="flex justify-center items-center gap-4 mt-[50px]">
              {computingItems.map((item, index) => {
                return (
                  <div
                    className="lg:w-[15%] w-[20%]"
                    key={item.id}
                    onMouseEnter={() => {
                      handleMouseEnter(index)
                    }}
                    onMouseLeave={handleMouseLeave}
                  >
                    <ActiveImg
                      normalSrc={item.contentImg}
                      hoverSrc={item.activeContentImg}
                      alt=""
                      className={item.className}
                      content={item.content}
                      activeClassName="shadow-[0_20px_50px_rgba(81,64,131,0.9)] rounded-[20px]"
                      active={index === activeIndex}
                      transitionDuration={500}
                    />
                  </div>
                )
              })}
            </div>
          </ScrollAnimation>
        </div>
      </div>
      {/* 第三部分 */}
      <div
        ref={el => {
          sectionRefs.current.prd_train = el
        }}
        className="bg-overlay-dark bg-cover flex-center h-[100vh] min-h-[550px] sm:min-h-[800px] md:min-h-[900px]"
        style={{
          backgroundImage: `url(${prdBg3})`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="max-w-[1000px] mx-auto flex flex-col justify-center items-center">
          <div className="flex-col flex-center">
            <ScrollAnimation>
              <div
                style={{ fontWeight: '900', letterSpacing: '4px' }}
                className="text-[30px] md:text-[40px] lg:text-[60px] text-white"
              >
                太初智训：大模型训推平台
              </div>
            </ScrollAnimation>
            <ScrollAnimation>
              <div className="w-[90vw] mt-[10px] mb-[40px] text-center text-[16px] text-white">
                原生多模态大模型训推平台，实现低代码全链路大模型训练部署
              </div>
            </ScrollAnimation>
            <a
              href={TRAIN_PLATFORM}
              target="_blank"
              className="lg:w-[140px] w-[120px] lg:h-[50px] md:h-[40] h-[30px] cursor-pointer px-[20px] text-[14px] lg:px-[30px] lg:text-[18px] hover:text-white text-white rounded-full flex-center hover:bg-gradient-to-r hover:from-[#86abff] hover:to-[#d1a2ff] bg-gradient-to-r from-[#1854f8] to-[#b678fe]"
              rel="noreferrer"
            >
              立即体验
            </a>
          </div>
          <ScrollAnimation>
            <AutoSwitch
              items={trainItems}
              interval={2000}
              startActiveIndex={0}
            />
          </ScrollAnimation>
        </div>
      </div>
      {/* 第四部分 */}
      <div
        ref={el => {
          sectionRefs.current.prd_digital = el
        }}
        className="bg-overlay-dark bg-cover flex-center h-[100vh] min-h-[550px] sm:min-h-[800px] md:min-h-[900px]"
        style={{
          backgroundImage: `url(${prdBg4})`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="max-w-[1000px] mx-auto flex flex-col justify-center items-center">
          <div className="flex-col flex-center">
            <ScrollAnimation>
              <div
                style={{ fontWeight: '900', letterSpacing: '4px' }}
                className="text-[30px] md:text-[40px] lg:text-[60px] text-white"
              >
                紫东太初数字人
              </div>
            </ScrollAnimation>
            <ScrollAnimation>
              <div className="w-[90vw] mt-[10px] mb-[40px] text-center text-[16px] text-white">
                互动体验像真人、形象音色随意变、科技服务有温度、7*24小时永在线
              </div>
            </ScrollAnimation>
          </div>
          <div className="flex gap-6">
            <a
              href={CHAT_DIGITAL}
              target="_blank"
              className="lg:w-[145px] w-[125px] lg:h-[50px] md:h-[40] h-[30px] cursor-pointer px-[20px] text-[14px] lg:px-[30px] lg:text-[18px] hover:text-white text-white rounded-full flex-center hover:bg-gradient-to-r hover:from-[#86abff] hover:to-[#d1a2ff] bg-gradient-to-r from-[#1854f8] to-[#b678fe]"
              rel="noreferrer"
            >
              体验对话
            </a>
            <a
              href={CREATE_DIGITAL}
              target="_blank"
              className={`${styles.botonElegante}  lg:w-[145px] w-[125px] lg:h-[50px] md:h-[40] h-[30px] cursor-pointer px-[14px] hover:text-white text-[14px] lg:px-[25px] lg:text-[18px] text-white rounded-full flex-center`}
              rel="noreferrer"
            >
              制作数字人
            </a>
          </div>
          <ScrollAnimation>
            <AutoSwitch
              items={digitalHumanItems}
              interval={2000}
              startActiveIndex={0}
            />
          </ScrollAnimation>
        </div>
      </div>
    </div>
  )
}

export default ProductCenter
